module.exports = __webpack_public_path__ + "img/xero-disconnect-btn.1d00e73a.svg";